import React from 'react';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { Card, CardBody, TableScroll } from '../../PanelComerciales.styles';
import SectionHeader from '../SectionHeader/SectionHeader';
import { AuditEntry } from '../../PanelComerciales.types';

interface AuditLogProps {
    entries: AuditEntry[];
}

const AuditLog: React.FC<AuditLogProps> = ({ entries }) => (
    <Card>
        <SectionHeader
            title='Actividades recientes'
            subtitle='Historial de cambios recientes.'
            icon={<HistoryOutlinedIcon style={{ color: '#4F46E5' }} />}
        />
        <CardBody>
            <TableScroll>
                <table>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Usuario</th>
                            <th>Acción</th>
                            <th>Detalle</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map((e, idx) => (
                            <tr key={`${e.date}-${idx}`}>
                                <td style={{ whiteSpace: 'nowrap' }}>{e.date}</td>
                                <td>{e.user}</td>
                                <td>{e.action}</td>
                                <td>{e.detail}</td>
                            </tr>
                        ))}
                        {entries.length === 0 && (
                            <tr>
                                <td colSpan={4} style={{ textAlign: 'center', padding: 24, color: '#9CA3AF' }}>
                                    Aún no hay actividad registrada.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </TableScroll>
        </CardBody>
    </Card>
);

export default AuditLog;
